import React from 'react';
import { BottomPanelContainer, BottomBody, PlainText } from './styles';

export const BottomPanel: React.FC = () => {
    return (
        <BottomPanelContainer>
            <BottomBody>
                <PlainText>
                    <a href="https://www.osinit.com/confidential">Политика конфиденциальности</a>
                </PlainText>
                <PlainText>
                    <a href="https://www.osinit.com/unsubscribe">Отказаться от рассылки</a>
                </PlainText>
            </BottomBody>
        </BottomPanelContainer>
    );
};